import { API_BASE_URL } from '../../../config/api';
import {
  CREATE_PAYMENT_REQUEST,
  CREATE_PAYMENT_SUCCESS,
  CREATE_PAYMENT_FAILURE,
  UPDATE_PAYMENT_REQUEST,
  UPDATE_PAYMENT_SUCCESS,
  UPDATE_PAYMENT_FAILURE,
} from './ActionType';

import axios from 'axios';

// ✅ FIXED ACTION CREATOR
export const createPayment = ({ orderId, jwt }) => async (dispatch) => {
  try {
    dispatch({ type: CREATE_PAYMENT_REQUEST });

    const config = {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${jwt}`,
      },
    };

    const { data } = await axios.post(
      `${API_BASE_URL}/api/payments/${orderId}`,
      {},
      config
    );

    dispatch({
      type: CREATE_PAYMENT_SUCCESS,
      payload: data,
    });

    // ✅ Just return the link, don’t redirect
    return data.payment_link_url;

  } catch (error) {
    dispatch({
      type: CREATE_PAYMENT_FAILURE,
      payload:
        error.response?.data?.message || error.message || "Payment error",
    });

    // ✅ Re-throw so component's catch block runs
    throw error;
  }
};





export const updatePayment = (reqData) => {
  return async (dispatch) => {
    console.log("update payment reqData ", reqData)
    dispatch(updatePaymentRequest());
    try {
      const config = {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${reqData.jwt}`,
        },
      };
      const response = await axios.get(`${API_BASE_URL}/api/payments?payment_id=${reqData.paymentId}&order_id=${reqData.orderId}`, config);
      console.log("updated data ---- ", response.data)
      dispatch(updatePaymentSuccess(response.data));
    } catch (error) {
      dispatch(updatePaymentFailure(error.message));
      console.log("catch error ", error)
    }
  };
};

export const updatePaymentRequest = () => {
  return {
    type: UPDATE_PAYMENT_REQUEST,
  };
};

export const updatePaymentSuccess = (payment) => {
  return {
    type: UPDATE_PAYMENT_SUCCESS,
    payload: payment,
  };
};

export const updatePaymentFailure = (error) => {
  return {
    type: UPDATE_PAYMENT_FAILURE,
    payload: error,
  };
};


